<template>
    <div>
 <div class="position-relative  rounded-2 mx-lg-10">
      <div class="container content-space-2 content-space-lg-3">
        <div class="row">
          <div class="col-lg-7 mb-9 mb-lg-0">
            <div class="pe-lg-6">
              <!-- Browser Device -->
              <figure class="comimg">
                <div class="comimg-frame">
                  <img class="comimg-img" src="@/assets/comback.png" alt="Image Description">
                </div>
              </figure>
              <!-- End Browser Device -->
            </div>
          </div>
          <!-- End Col -->

          <div class="col-lg-5 comcatch">
            <!-- Heading -->
            <div class="cpraise mb-4">
              <h2><p>Life is too short.<br>You need PA Soft.</p>
              </h2>
              <p class="sub-cpraise">기업이 집중해야 할 업무에 빠르고 정확한 대응할 수 있도록
                <br>플랫폼을 통해 단순 반복 업무를 대체함에 따라
                <br>효율적인 인적자원의 이용과 더불어 보다 큰 성과를  <br>실현할 수 있습니다.</p>
              
            </div>
            <!-- End Heading -->

            <!-- List Checked -->
            <ul class="list-checked list-checked-primary mb-5">
              <li class="list-checked-item">맞춤형 회계 결산 데이터베이스 운용</li>
              <li class="list-checked-item">재무제표 사전제출 컨설팅/ 데이터 리뷰</li>
              <li class="list-checked-item">결산 자동화 / 서비스 유지 관리</li>
              <li class="list-checked-item">회계감사 대응 및 최신 회계기준 결산 트렌드 반영</li>
            </ul>
            <!-- End List Checked -->

            <!-- End Row -->
          </div>
          <!-- End Col -->
        </div>
        <!-- End Row -->
      </div>
    </div>
    <!-- End Features -->


    </div>
</template>

<script>
export default {
    name:'MiddlePage',
    methods:{

    }

}
</script>

<style scoped>
@media (min-width: 992px) {
.pe-lg-6 {
    padding-right: 2.5rem!important;
}
.content-space-lg-3 {
    padding-top: 7.5rem!important;
    padding-bottom: 7.5rem!important;
}
}

.comimg {
    position: relative;
    z-index: 1;
    display: block;
    max-width: 100%;
    width: 50rem;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    
}

.comimg-frame {
    background: #fff;
    
    border-radius: 0.5rem;
    
}

.comimg-img {
    max-width: 100%;
    height: auto;
    border-radius: 0.5rem;
}

.list-checked-primary .list-checked-item::before {
    background-image: url(@/assets/checked.svg);
}

.list-checked-item::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.25rem;
    height: 1.25rem;
    background-image: url(@/assets/checked.svg);
    background-repeat: no-repeat;
    background-position: right center;
    background-size: 1.25rem 1.25rem;
    content: '';
    margin-top: 0.125rem;
}

.list-checked-item {
    position: relative;
    color: #677788;
    padding-left: 2rem;
}

.list-checked {
    padding-left: 0;
    list-style: none;
}


.cpraise h2 {font-weight: 800;
font-size: 50px; 
margin-bottom:0px;}

.sub-cpraise { margin-top:30px; 
margin-bottom:50px;
font-weight:400; 
font-size:17px;}

.comcatch {padding-left: calc(var(--bs-gutter-x) * 2.5)}

</style>